import { createSelector } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { QuoteVendor } from './models';
import { baseApi } from '@centerpiece/components';

export const quote_vendor = baseApi
  .enhanceEndpoints({ addTagTypes: ['QuoteVendors', 'QuoteVendor'] })
  .injectEndpoints({
    endpoints: builder => ({
      getQuoteVendors: builder.query<QuoteVendor[], { params?: object }>({
        query: ({ params }: { params?: object }) => ({
          url: 'quote_vendor',
          method: 'GET',
          params: params,
        }),
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({
                  type: 'QuoteVendor' as const,
                  id,
                })),
                'QuoteVendors',
              ]
            : ['QuoteVendors'],
      }),
      getQuoteVendor: builder.query<
        QuoteVendor,
        { id: number; params?: object }
      >({
        query: ({ id, params }: { id: number; params?: object }) => ({
          url: `quote_vendor/${id}`,
          method: 'GET',
          params: params,
        }),
        providesTags: (result, error, arg) => [
          { type: 'QuoteVendor', id: arg.id },
        ],
        // configuration for an individual endpoint, overriding the api setting
        keepUnusedDataFor: 90,
      }),
      createQuoteVendor: builder.mutation({
        query: request => ({
          url: 'quote_vendor',
          method: 'POST',
          body: request,
        }),
        invalidatesTags: ['QuoteVendors'],
      }),
      patchQuoteVendor: builder.mutation<QuoteVendor, QuoteVendor>({
        query: request => ({
          url: `quote_vendor/${request.id}`,
          method: 'PATCH',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'QuoteVendor', id: arg.id },
        ],
      }),
      updateQuoteVendor: builder.mutation<QuoteVendor, QuoteVendor>({
        query: request => ({
          url: `quote_vendor/${request.id}`,
          method: 'PUT',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'QuoteVendor', id: arg.id },
        ],
      }),
      deleteQuoteVendor: builder.mutation<QuoteVendor, number>({
        query: id => ({
          url: `quote_vendor/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) =>
          result
            ? [{ type: 'QuoteVendor' as const, arg }, 'QuoteVendors']
            : ['QuoteVendors'],
      }),
    }),
  });

// Auto-generated hooks
export const {
  useGetQuoteVendorsQuery,
  useGetQuoteVendorQuery,
  useCreateQuoteVendorMutation,
  usePatchQuoteVendorMutation,
  useUpdateQuoteVendorMutation,
  useDeleteQuoteVendorMutation,
  usePrefetch: useQuoteVendorsPrefetch,
} = quote_vendor;
const selectQuoteVendorsRoot = quote_vendor.endpoints.getQuoteVendors.select(
  {}
);
export const selectQuoteVendors = createSelector(
  selectQuoteVendorsRoot,
  quote_vendor => quote_vendor.data || []
);
